import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const formatLocationCode = (location = {}) => {
  const parts = [
    location.room,
    location.section,
    location.shelf,
    location.column,
    location.bin,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean);
  return parts.join("-");
};

export const normalizeProductLocations = (product = {}) => {
  const inventory = Array.isArray(product?.inventoryLocations)
    ? product.inventoryLocations
    : [];
  const mapped = inventory
    .map((location) => {
      const code = formatLocationCode(location);
      return {
        code,
        quantity: Number(location?.quantity ?? 0),
      };
    })
    .filter((location) => location.code);

  if (mapped.length > 0) return mapped;

  const snapshotText = String(
    product?.locationText || product?.pickLocations || "",
  ).trim();
  if (snapshotText) {
    return snapshotText
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean)
      .map((code) => ({ code, quantity: null }));
  }

  const fallback = String(product?.location || "").trim();
  return fallback ? [{ code: fallback, quantity: null }] : [];
};

export const formatProductLocationsText = (product = {}) => {
  const locations = normalizeProductLocations(product);
  if (locations.length === 0) return "";
  return locations
    .map((location) =>
      location.quantity == null
        ? location.code
        : `${location.code} × ${location.quantity}`,
    )
    .join(", ");
};

const ProductLocationsSummary = ({ product, compact = false }) => {
  const locations = normalizeProductLocations(product);

  if (locations.length === 0) {
    return <span className="text-muted">Not set</span>;
  }

  const renderLine = (location) =>
    location.quantity == null
      ? location.code
      : `${location.code} × ${location.quantity}`;

  if (compact && locations.length > 1) {
    const first = renderLine(locations[0]);
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>
            {locations.map((location, idx) => (
              <div key={`${location.code}-${idx}`}>{renderLine(location)}</div>
            ))}
          </Tooltip>
        }
      >
        <span role="button" className="text-decoration-underline">
          {first} + {locations.length - 1} more
        </span>
      </OverlayTrigger>
    );
  }

  return <span className="small">{formatProductLocationsText(product)}</span>;
};

export default ProductLocationsSummary;
